import { render, staticRenderFns } from "./OptionValueComponent.vue?vue&type=template&id=4f0af5a8&scoped=true&"
import script from "./OptionValueComponent.vue?vue&type=script&lang=js&"
export * from "./OptionValueComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0af5a8",
  null
  
)

export default component.exports